document.addEventListener('DOMContentLoaded', () => {
	const toggle = document.querySelector('.business-category-toggle')
	const toggleBtn = toggle?.querySelector('button')
	const toggleList = toggle?.querySelector('ul')

	toggleBtn?.addEventListener('click', () => {
		toggle.classList.toggle('open')
	})

	if (toggleList) {
		toggle.setAttribute('style', `--list-height: ${toggleList.scrollHeight}px;`)

		window.addEventListener('resize', () => {
			toggle.setAttribute('style', `--list-height: auto;`)
			toggle.setAttribute(
				'style',
				`--list-height: ${toggleList.scrollHeight}px;`
			)
		})
	}
})
